module.exports = __webpack_public_path__ + "img/ubuntu.173126df.png";